import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { useMediaQuery } from '@vueuse/core';
import NavAndTitleBarDesktop from '@/components/NavAndTitleBarDesktop.vue';
import NavAndTitleBarMobile from '@/components/NavAndTitleBarMobile.vue';
import { computed } from 'vue';
import { useRoute } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'NavAndTitleBar',
  setup(__props) {

const pagesToList = [
  'home',
  'wordle-helper',
  'vacation-planner',
];

const pagesInProgress = [
  'task-tracker',
];

const showDesktopNav = useMediaQuery('(min-width: 461px)');

const route = useRoute();
const showWipBanner = computed(() => typeof route.name === 'string' && pagesInProgress.includes(route.name));


return (_ctx: any,_cache: any) => {
  return (_unref(showDesktopNav))
    ? (_openBlock(), _createBlock(NavAndTitleBarDesktop, {
        key: 0,
        "listed-pages": pagesToList,
        "show-wip-banner": _unref(showWipBanner)
      }, null, 8, ["show-wip-banner"]))
    : (_openBlock(), _createBlock(NavAndTitleBarMobile, {
        key: 1,
        "listed-pages": pagesToList,
        "show-wip-banner": _unref(showWipBanner)
      }, null, 8, ["show-wip-banner"]))
}
}

})